import { BreadcrumbJsonLd } from "next-seo";
import { ItemListElements } from "next-seo/lib/types";

export const BreadcrumbsSchema = ({ items }: { items: ItemListElements[] }) => (
  <BreadcrumbJsonLd itemListElements={items} />
);
